import { observer } from "mobx-react-lite";
import { Button, message, Result, Skeleton, Spin } from "antd";
import { useStore } from "../../stores/root-store-context";
import { PlusOutlined } from "@ant-design/icons";
import { MemberRow } from "./MemberRow";

export const MembersTable = observer(() => {
  const { applicationStore, membersStore } = useStore();

  const getObject = (array: any[]): any => {
    const obj = {} as any;
    array.forEach((data: any) => {
      obj[data.name] = data.value;
    });
    return obj;
  };

  return (
    <Spin spinning={membersStore.isLoadMemders} style={{ minHeight: 200 }}>
      {membersStore.isLoadMemders === false &&
        applicationStore.comiteeId &&
        !applicationStore.isFinCen && (
          <Button
            data-testid="mat-btn-add-member"
            type="primary"
            shape="circle"
            style={{ marginTop: 12, marginBottom: 20 }}
            icon={<PlusOutlined />}
            size="large"
            onClick={() => {
              membersStore.addMember();
            }}
          />
        )}
      {applicationStore.comiteeId ? (
        membersStore.isLoadMemders === false ? (
          membersStore.members.length === 0 ? (
            <Result
              title={`No existing members on ${applicationStore.comiteeName}`}
            />
          ) : (
            membersStore.members.map((el, index) => {
              return (
                <MemberRow
                  key={el.key}
                  MemberInfo={el}
                  changeForm={(key, changedFields, allFields) => {
                    membersStore.editMember(key, getObject(allFields));
                  }}
                  saveForm={(key: string) => {
                    membersStore.saveMember(
                      key,
                      {
                        committeeName: applicationStore.comiteeName,
                        propertyName: applicationStore.propertyName,
                        groupName: applicationStore.groupSelectValue || applicationStore.comiteeName,
                        committeeKey: Number(applicationStore.comiteeId) || 0,
                      },
                      (errMsg) => message.error(errMsg)
                    );
                  }}
                  removeForm={(key: string) => {
                    membersStore.removeMember(key);
                  }}
                  onPressEnterForm={(key: string) => {
                    membersStore.getMemberInfoByAccount(
                      key,
                      applicationStore.selectedPropertyId
                    );
                  }}
                  background={index % 2 ? "#ffffff" : "#f2f2f2"}
                />
              );
            })
          )
        ) : (
          <>
            <Skeleton />
            <Skeleton />
          </>
        )
      ) : (
        <></>
      )}
    </Spin>
  );
});